export function eventTargetAsNode(
  target: EventTarget | null | undefined,
): Node | null {
  return target instanceof Node ? target : null;
}
